type BrandLogoProps = {
	src: string;
	className?: string;
};

export function BrandLogo({ src, className = "h-24 w-auto" }: BrandLogoProps) {
	return (
		<div className="flex justify-center mb-6">
			<img src={src} alt="Brand Logo" className={className} />
		</div>
	);
}
